NodeList.prototype.forEach = NodeList.prototype.forEach || Array.prototype.forEach;

const init = hashLinks => {
    let browser = navigator.userAgent;

    if (hashLinks && browser.indexOf('Version/8.0') === -1) {
        hashLinks.forEach(link => {
            link.addEventListener('click', e => {
                const href = link.href,
                    target = document.getElementById(href.split('#')[1]);
                if (target) {
                    e.preventDefault();
                    animateScroll(target);
                }
            });
        });
    }
};

const animateScroll = target => {
    const elem = document.scrollingElement || document.documentElement;

    var start = new Date().getTime(),
        timer = setInterval(() => {
            var step = Math.min(1, (new Date().getTime() - start) / 500);

            elem['scrollTop'] = (window.pageYOffset + step * (target.offsetTop - window.pageYOffset));

            if (step === 1) {
                clearInterval(timer);
            }
        }, 25);
    elem['scrollTop'] = window.pageYOffset;
};

export default () => init(document.querySelectorAll('a[href*="#"]'));
